import { render, staticRenderFns } from "./TheDefaultView.vue?vue&type=template&id=97b9ac0e"
import script from "./TheDefaultView.vue?vue&type=script&lang=js"
export * from "./TheDefaultView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports